(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // Expose the full header-group height (announcement bar + header) so the
  // transparent-overlay layout can pull the page content up by the correct
  // amount. Dawn's built-in --header-height only covers the header row.
  (function () {
    function setHeaderGroupHeight() {
      // Shopify applies the group class to each section wrapper in the group
      // (announcement bar + header), and each wrapper also has its own id, so
      // always sum every member to get the full group height.
      const members = document.querySelectorAll('.shopify-section-group-header-group');
      if (!members.length) return;
      let height = 0;
      members.forEach((el) => (height += el.offsetHeight));
      document.documentElement.style.setProperty(
        '--header-group-height',
        `${Math.round(height)}px`
      );
      // Header ROW only (excludes the announcement bar). The hero overlay
      // uses this so the hero starts below the announcement bar instead of
      // sliding underneath it, on every breakpoint.
      const headerMember = document.querySelector(
        '.shopify-section-group-header-group.section-header'
      );
      if (headerMember) {
        document.documentElement.style.setProperty(
          '--header-overlay-height',
          `${Math.round(headerMember.offsetHeight)}px`
        );
      }
    }

    setHeaderGroupHeight();
    window.addEventListener('resize', setHeaderGroupHeight);
    window.addEventListener('load', setHeaderGroupHeight);
    document.addEventListener('shopify:section:load', setHeaderGroupHeight);
    document.addEventListener('shopify:section:unload', setHeaderGroupHeight);
  })();

  // Open the header nav dropdowns on hover (desktop / fine pointer only).
  // Reuses the native <details open> attribute so Dawn's existing animation,
  // focus handling and click behaviour keep working; touch devices fall back
  // to the default click-to-open. A small close delay avoids flicker when the
  // pointer travels from the summary down into the dropdown panel.
  (function () {
    function supportsHover() {
      return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function bindHoverMenus() {
      if (!supportsHover()) return;
      const menus = document.querySelectorAll('header-menu');
      menus.forEach((menu) => {
        if (menu.dataset.hoverBound) return;
        menu.dataset.hoverBound = 'true';
        const details = menu.querySelector('details');
        if (!details) return;
        const summary = details.querySelector('summary');
        let closeTimer;

        const open = () => {
          window.clearTimeout(closeTimer);
          if (!details.open) {
            details.setAttribute('open', '');
            if (summary) summary.setAttribute('aria-expanded', 'true');
          }
        };
        const close = () => {
          closeTimer = window.setTimeout(() => {
            if (typeof menu.close === 'function') menu.close();
          }, 150);
        };

        menu.addEventListener('mouseenter', open);
        menu.addEventListener('mouseleave', close);
      });
    }

    bindHoverMenus();
    document.addEventListener('shopify:section:load', bindHoverMenus);
  })();

  } catch(e) { console.error(e); }
})();
})();
